export type AssignmentMarket = "intl" | "ar";

export function assignmentMarketFromScope(scope: string): AssignmentMarket {
  return scope === "province_ar" || scope === "city_ar" ? "ar" : "intl";
}

export function heroCtaGeoKey(scope: "province_ar" | "city_ar", geoCode: string): string {
  return `${scope}:${geoCode.trim()}`;
}

export function normalizeCtaCityKey(s: string): string {
  return String(s || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ");
}

/**
 * Clave can\u00f3nica para scope landing_path: lowercase, sin query/hash, leading
 * slash garantizado, sin trailing slash (excepto ra\u00edz "/"). MISMA funci\u00f3n
 * (copiada) en el worker: normalizeWorkerLandingPathKey \u2014 mantener en sync.
 */
export function normalizeLandingPathKey(s: string): string {
  let p = String(s || "").trim().toLowerCase();
  if (!p) return "";
  p = p.split("?")[0].split("#")[0];
  if (!p.startsWith("/")) p = `/${p}`;
  p = p.replace(/\/{2,}/g, "/");
  if (p.length > 1) p = p.replace(/\/+$/, "");
  return p || "/";
}

import { gbaPartidoForCity } from "./gbaPartidoMap.js";

/** Cascada variantes — paridad worker + Hero CTA (city_ar partido GBA). */
export function buildVariantGeoOrder(input: {
  country: string;
  province: string;
  city: string;
  stateAbbr?: string | null;
  /** Path SPA/SSR actual — habilita scope landing_path (gana sobre todo geo). */
  landingPath?: string | null;
  cityToPartido?: (city: string) => string | null;
}): Array<[string, string]> {
  const country = input.country.trim().toUpperCase();
  const cityTrim = input.city.trim();
  const partidoFn = input.cityToPartido ?? gbaPartidoForCity;
  const geoOrder: Array<[string, string]> = [];

  // landing_path primero: asignación explícita del admin por ruta (ej.
  // /hispanic-influencer) pisa toda la cascada geo. Paridad worker.
  const landingKey = normalizeLandingPathKey(input.landingPath || "");
  if (landingKey) geoOrder.push(["landing_path", landingKey]);

  if (cityTrim && country === "AR") {
    geoOrder.push(["city_ar", cityTrim]);
    const partido = partidoFn(cityTrim);
    if (partido && normalizeCtaCityKey(partido) !== normalizeCtaCityKey(cityTrim)) {
      geoOrder.push(["city_ar", partido]);
    }
  }
  if (cityTrim) geoOrder.push(["city", cityTrim]);
  if (country === "AR" && input.province.trim()) {
    geoOrder.push(["province_ar", input.province.trim()]);
  }
  if (country === "US" && input.stateAbbr) {
    geoOrder.push(["state_us", input.stateAbbr]);
  }
  if (country) geoOrder.push(["country", country]);
  geoOrder.push(["DEFAULT", "DEFAULT"]);
  return geoOrder;
}

export function fnv1a32(str: string): number {
  let hash = 2166136261;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = (hash * 16777619) >>> 0;
  }
  return hash >>> 0;
}